<template>
       <div class="head-title">
        <div class="left">
          <ul class="breadcrumb">
            <li>
              <a href="#">{{ $t("management") }} {{ $t("projects") }}</a>
            </li>
            <li>-</li>
            <li>
              <a href="#">{{ $t("receipts") }} {{ $t("suppliers") }}</a>
            </li>
            <li>-</li>
            <li>
              <a class="active" href="#">{{ $t("receipt") }} {{ $t("supplier") }} - {{ this.$route.params.id }}</a>
            </li>
          </ul>
        </div>
      </div>
      <div class="main">
        <div class="head">
          <div class="head1">
            <h3>{{ $t("receipt") }} {{ $t("supplier") }} - {{ this.$route.params.id }}</h3>
          </div>
          <div class="head2">
            <div class="action-dropdown">
              <button
                class="btn btn-primary dropdown-toggle"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i class="bi bi-menu-button"></i>
                {{ $t("actions") }}
              </button>
              <ul class="dropdown-menu">
                <li>
                  <a class="dropdown-item" href="#" @click.prevent="exportToPDF">
                    <i class="bi bi-filetype-pdf me-2"></i>
                    {{ $t("PDF") }}
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="body">
          <div class="part1">
            <div class="part11">
              <div class="mb-2 row">
                <label for="inputEmail3" class="col-sm-2 col-form-label-sm">{{ $t("number") }}</label>
                <div class="col-sm-7">PYT-{{ this.$route.params.id }}</div>
              </div>
              <div class="mb-2 row">
                <label for="inputEmail3" class="col-sm-2 col-form-label-sm">{{ $t("date") }}</label>
                <div class="col-sm-7">
                  <input type="date" class="form-control form-control-sm" id="inputEmail3" v-model="alldata.date" disabled />
                </div>
              </div>
              <div class="mb-2 row">
                <label for="inputEmail3" class="col-sm-2 col-form-label-sm">{{ $t("description") }}</label>
                <div class="col-sm-7">
                  <textarea class="form-control" disabled id="exampleFormControlTextarea1" rows="3"
                    v-model="alldata.description"></textarea>
                </div>
              </div>
              <div class="mb-2 row">
                <label for="inputEmail3" class="col-sm-2 col-form-label-sm">{{ $t("Account") }}</label>
                <div class="col-sm-7">
                  {{ alldata.namear }}
                </div>
              </div>
              <div class="mb-2 row">
                <label for="inputEmail3" class="col-sm-2 col-form-label-sm">{{ $t("project") }}</label>
                <div class="col-sm-7">
                  {{ alldata.projectname }}
                </div>
              </div>
              <div class="mb-2 row">
                <label for="inputEmail3" class="col-sm-2 col-form-label-sm">{{ $t("amount") }}</label>
                <div class="col-sm-7">
                  <input type="number" disabled class="form-control form-control-sm" id="inputEmail3"
                    v-model="alldata.amount" />
                </div>
              </div>
              <div class="mb-2 row" v-if="attachments.length > 0">
                <label class="col-sm-2 col-form-label-sm">
                  <i class="bi bi-pin-angle-fill"></i> {{ $t("attachments") }}
                </label>
                <div class="col-sm-7">
                  <table class="table" style="width: 50%">
                    <thead>
                      <tr>
                        <th>{{ $t("name") }}</th>
                        <th>{{ $t("download") }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="file in attachments" :key="file.name">
                        <td>{{ file.name }}</td>
                        <td>
                          <a :href="`${url}/supplierreceipt/${file.name}`" download>
                            <i class="bi bi-download"></i>
                          </a>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="part11">
              <h4>{{ $t("data") }} {{ $t("customer") }}</h4>
              <div class="mb-2 row">
                <label for="inputEmail3" class="col-sm-3 col-form-label-sm">
                  {{ $t("name") }}
                </label>
                <div class="col-sm-7">
                  {{ alldata.cname }}
                </div>
              </div>
              <div class="mb-2 row">
                <label for="inputEmail3" class="col-sm-3 col-form-label-sm">
                  {{ $t("mobile") }}
                </label>
                <div class="col-sm-7">
                  {{ alldata.cmobile }}
                </div>
              </div>
              <div class="mb-2 row">
                <label for="inputEmail3" class="col-sm-3 col-form-label-sm">
                  {{ $t("email") }}
                </label>
                <div class="col-sm-7">
                  {{ alldata.cemail }}
                </div>
              </div>
              <div class="mb-2 row">
                <label for="inputEmail3" class="col-sm-3 col-form-label-sm">
                  {{ $t("tax") }}
                </label>
                <div class="col-sm-7">
                  {{ alldata.ctax }}
                </div>
              </div>
            </div>
          </div>
          <!-- Hidden div for PDF generation -->
          <div id="pdf-content" style="display: none;">
            <div style="font-family: Arial, sans-serif; font-size: 12px; color: #333; direction: rtl; padding: 10px; background-color: #fff; width: 100%; min-height: 842px;">
              <!-- Header -->
              <div style="background-color: #f4f4f4; padding: 15px; border-bottom: 3px solid #005577; margin-bottom: 20px; display: flex; align-items: center;">
                <img :src="imgurl" crossorigin="anonymous" style="height: 60px; width: auto; margin-left: 15px;" />
                <div style="flex-grow: 1; text-align: right;">
                  <h1 style="font-size: 18px; color: #005577; margin: 0;">{{ $t("receipt") }} {{ $t("supplier") }}</h1>
                  <p style="font-size: 12px; margin: 5px 0 0; color: #555;">{{ $t("number") }}: PYT-{{ this.$route.params.id }}</p>
                </div>
              </div>
              <!-- Body -->
              <div style="display: flex; margin-bottom: 20px;">
                <!-- Receipt Details -->
                <div style="width: 50%; padding: 10px;">
                  <h2 style="font-size: 14px; color: #005577; border-bottom: 1px solid #ddd; padding-bottom: 5px; margin-bottom: 10px;">{{ $t("details") }}</h2>
                  <table style="width: 100%; border-collapse: collapse;">
                    <tr style="background-color: #f9f9f9;">
                      <th style="border: 1px solid #ddd; padding: 8px; text-align: right; font-weight: bold; color: #005577;">{{ $t("date") }}</th>
                      <td style="border: 1px solid #ddd; padding: 8px; text-align: right;">{{ alldata.date || 'N/A' }}</td>
                    </tr>
                    <tr>
                      <th style="border: 1px solid #ddd; padding: 8px; text-align: right; font-weight: bold; color: #005577;">{{ $t("description") }}</th>
                      <td style="border: 1px solid #ddd; padding: 8px; text-align: right;">{{ alldata.description || 'N/A' }}</td>
                    </tr>
                    <tr style="background-color: #f9f9f9;">
                      <th style="border: 1px solid #ddd; padding: 8px; text-align: right; font-weight: bold; color: #005577;">{{ $t("Account") }}</th>
                      <td style="border: 1px solid #ddd; padding: 8px; text-align: right;">{{ alldata.namear || 'N/A' }}</td>
                    </tr>
                    <tr>
                      <th style="border: 1px solid #ddd; padding: 8px; text-align: right; font-weight: bold; color: #005577;">{{ $t("project") }}</th>
                      <td style="border: 1px solid #ddd; padding: 8px; text-align: right;">{{ alldata.projectname || 'N/A' }}</td>
                    </tr>
                    <tr style="background-color: #f9f9f9;">
                      <th style="border: 1px solid #ddd; padding: 8px; text-align: right; font-weight: bold; color: #005577;">{{ $t("amount") }}</th>
                      <td style="border: 1px solid #ddd; padding: 8px; text-align: right;">{{ alldata.amount ? Number(alldata.amount).toFixed(2) : '0.00' }}</td>
                    </tr>
                  </table>
                </div>
                <!-- Customer Data -->
                <div style="width: 50%; padding: 10px;">
                  <h2 style="font-size: 14px; color: #005577; border-bottom: 1px solid #ddd; padding-bottom: 5px; margin-bottom: 10px;">{{ $t("data") }} {{ $t("customer") }}</h2>
                  <table style="width: 100%; border-collapse: collapse;">
                    <tr style="background-color: #f9f9f9;">
                      <th style="border: 1px solid #ddd; padding: 8px; text-align: right; font-weight: bold; color: #005577;">{{ $t("name") }}</th>
                      <td style="border: 1px solid #ddd; padding: 8px; text-align: right;">{{ alldata.cname || 'N/A' }}</td>
                    </tr>
                    <tr>
                      <th style="border: 1px solid #ddd; padding: 8px; text-align: right; font-weight: bold; color: #005577;">{{ $t("mobile") }}</th>
                      <td style="border: 1px solid #ddd; padding: 8px; text-align: right;">{{ alldata.cmobile || 'N/A' }}</td>
                    </tr>
                    <tr style="background-color: #f9f9f9;">
                      <th style="border: 1px solid #ddd; padding: 8px; text-align: right; font-weight: bold; color: #005577;">{{ $t("email") }}</th>
                      <td style="border: 1px solid #ddd; padding: 8px; text-align: right;">{{ alldata.cemail || 'N/A' }}</td>
                    </tr>
                    <tr>
                      <th style="border: 1px solid #ddd; padding: 8px; text-align: right; font-weight: bold; color: #005577;">{{ $t("tax") }}</th>
                      <td style="border: 1px solid #ddd; padding: 8px; text-align: right;">{{ alldata.ctax || 'N/A' }}</td>
                    </tr>
                  </table>
                </div>
              </div>
              <!-- Footer -->
              <div style="position: fixed; bottom: 20px; width: 700px; text-align: center; font-size: 10px; color: #777; border-top: 1px solid #ddd; padding-top: 10px;">
                <p style="margin: 2px 0;">{{ $t("generated_on") }}: {{ new Date().toLocaleDateString() }}</p>
                <p style="margin: 2px 0;">{{ $store.state.cnum[0].cname || 'Company Name' }} | {{ $store.state.cnum[0].caddress || 'Company Address' }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
  </template>
  <script>
  import store from "@/store";
  import axios from "axios";
  import { mapActions } from "vuex";
  import html2pdf from "html2pdf.js";
  
  export default {
    components: {},
    props: ["css"],
    async mounted() {
      this.url = store.state.imgurl;
      this.imgurl = store.state.imgurl + `/clogo/${store.state.cnum[0].cnum}.png`;
      const data = await axios.get(`/data/receiptview/${this.$route.params.id}`);
      if (data.status == 200) {
        this.alldata = data.data.data[0];
        if (this.alldata.fileurl) {
          try {
            this.attachments = JSON.parse(this.alldata.fileurl);
          } catch (e) {
            console.error("Error parsing fileurl:", e);
            this.attachments = [];
          }
        }
      }
    },
    data() {
      return {
        disabled: false,
        alldata: "",
        url: "",
        imgurl: "",
        customerdata: [],
        attachments: [],
      };
    },
    methods: {
      exportToPDF() {
        html2pdf(document.getElementById("pdf-content").innerHTML, {
          margin: 0.5,
          filename: `supplier-receipt-PYT-${this.$route.params.id}.pdf`,
          image: { type: "jpeg", quality: 100 },
          html2canvas: { scale: 2, useCORS: true },
          jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
        });
      },
      ...mapActions(["redirectTo"]),
    },
    watch: {},
  };
  </script>
  <style lang="scss" scoped>
  .page {
    padding: 0.5%;
  }
  
  .main {
    width: 98%;
    margin: 1%;
    padding: 1%;
    border-radius: 5px;
    border: ridge 0.5px;
  }
  
  .head {
    padding: 0.25%;
    display: flex;
    border-bottom-style: ridge;
  }
  
  .head1 {
    width: 70%;
  }
  
  input {
    margin: 0.5%;
    padding: 0.5%;
    border: none;
    border-radius: 5px;
    background-color: #eee;
    text-align: center;
  }
  
  .head2 {
    width: 30%;
    text-align: center;
  }
  
  .action-dropdown {
    position: relative;
    display: inline-block;
  
    .dropdown-toggle {
      padding: 0.75rem 1.5rem;
      border-radius: 0.5rem;
      display: inline-flex;
      align-items: center;
      gap: 0.75rem;
      background-color: rgba(98, 153, 174, 255);
      transition: all 0.2s ease;
  
      &:hover {
        background-color: #4b7f8e;
      }
    }
  
    .dropdown-menu {
      border-radius: 0.5rem;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
      border: 1px solid #dee2e6;
      min-width: 200px;
    }
  
    .dropdown-item {
      padding: 0.75rem 1.5rem;
      display: flex;
      align-items: center;
      color: #212529;
      transition: all 0.2s ease;
  
      &:hover {
        background: #f8f9fa;
      }
  
      i {
        width: 1.25rem;
        text-align: center;
      }
    }
  }
  
  .table {
    margin-top: 1%;
  }
  
  table thead tr {
    border-radius: 5px;
    background-color: #eee;
  }
  
  select {
    width: 15%;
    margin: 0.5%;
    border: none;
    border-radius: 5px;
    background-color: #eee;
  }
  
  .part1 {
    display: flex;
    width: 100%;
  }
  
  .part11 {
    width: 50%;
    padding: 2%;
  }
  
  .body1 {
    padding: 1%;
    width: 100%;
    display: flex;
  }
  
  .group {
    width: 50%;
    padding: 1%;
  }
  
  @media screen and (max-width: 576px) {
    .table {
      width: 90%;
      margin-left: 5%;
      margin-right: 5%;
      background-color: white;
      font-size: xx-small;
    }
  
    .action-dropdown {
      width: 100%;
  
      .dropdown-toggle {
        width: 100%;
        justify-content: center;
      }
  
      .dropdown-menu {
        width: 100%;
      }
    }
  }
  </style>
  <i18n>
  {
    "en": {
      "actions": "Actions",
      "PDF": "Export to PDF",
      "details": "Details",
      "generated_on": "Generated on"
    },
    "ar": {
      "actions": "الإجراءات",
      "PDF": "تصدير إلى PDF",
      "details": "التفاصيل",
      "generated_on": "تم الإنشاء في"
    }
  }
  </i18n>